import { autoAnimatePlugin } from "@formkit/auto-animate/vue";
import FloatingVue from "floating-vue";
import "floating-vue/dist/style.css";
import { createPinia } from "pinia";
import { createApp } from "vue";
import Vue3Lottie from "vue3-lottie";
import App from "./App.vue";
import router from "./router/index";

FloatingVue.options.themes.tooltip.triggers = ["hover", "focus", "touch"];

// Quasar
import Quasar from "plugins/quasar";

// Internationalization
import i18n from "plugins/i18n";

// Import custom styles
import "styles/main.scss";

// Wrapper components
import WrapperComponents from "plugins/wrapper-components";

// Drawer module
import drawerHelper from "shared/components/wrappers/drawer/drawerHelper";

// This will enable Sentry error logging
import Sentry from "plugins/sentry";

// Layouts
import { clearAuthStorage } from "composables/useHelpers";
import layouts from "./layouts";

// @todo: Move to a sepearate file
Object.defineProperty(String.prototype, "capitalize", {
  value: function () {
    return this.charAt(0).toUpperCase() + this.slice(1);
  },
  enumerable: false,
});

const pinia = createPinia();

const app = createApp(App);

app
  .use(pinia)
  .use(router)
  .use(i18n)
  .use(FloatingVue)
  .use(layouts)
  .use(Quasar)
  .use(Sentry)
  .use(WrapperComponents)
  .use(drawerHelper)
  .use(autoAnimatePlugin)
  .use(Vue3Lottie);

//Global Variables
app.config.globalProperties.$laravelUrl = import.meta.env.VITE_LARAVEL_URL;

const user = localStorage.getItem("user");
if (user) {
  try {
    let role = JSON.parse(user).role[0];
    if (!role) {
      clearAuthStorage();
    }
  } catch (e) {
    console.error("Error parsing user from localStorage:", e);
    clearAuthStorage();
  }
} else {
  clearAuthStorage();
}

if (import.meta.env.NODE_ENV === "development") {
  app.config.performance = true;
}

app.mount("#app");
